/*
 * Cherry tracking — Meta Pixel + TikTok Pixel + Google Analytics 4
 *
 * Eventos disparados:
 *   - page_view (auto)
 *   - view_item       (en PDP)
 *   - add_to_cart     (al agregar)
 *   - begin_checkout  (al ir al checkout)
 *   - purchase        (en thank-you, configurado vía Shopify Customer Events)
 *
 * Configuración de Pixel IDs se hace desde theme editor → settings.
 * Para Conversions API y Events API server-side: configurar desde
 * Shopify admin → Settings → Customer Events.
 */

(() => {
  const config = window.cherryTrackingConfig || {};
  const metaId = config.metaPixelId || '';
  const tiktokId = config.tiktokPixelId || '';
  const gaId = config.googleAnalyticsId || '';
  const currency = config.currency || 'MXN';

  const loadMetaPixel = (id) => {
    if (!id) return;
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', id);
    window.fbq('track', 'PageView');
  };

  const loadTikTokPixel = (id) => {
    if (!id) return;
    !(function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      var ttq = (w[t] = w[t] || []);
      ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie', 'holdConsent', 'revokeConsent', 'grantConsent'];
      ttq.setAndDefer = function (t, e) {
        t[e] = function () {
          t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
        };
      };
      for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
      ttq.instance = function (t) {
        for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
        return e;
      };
      ttq.load = function (e, n) {
        var r = 'https://analytics.tiktok.com/i18n/pixel/events.js',
          o = n && n.partner;
        ttq._i = ttq._i || {};
        ttq._i[e] = [];
        ttq._i[e]._u = r;
        ttq._t = ttq._t || {};
        ttq._t[e] = +new Date();
        ttq._o = ttq._o || {};
        ttq._o[e] = n || {};
        n = document.createElement('script');
        n.type = 'text/javascript';
        n.async = !0;
        n.src = r + '?sdkid=' + e + '&lib=' + t;
        e = document.getElementsByTagName('script')[0];
        e.parentNode.insertBefore(n, e);
      };
      ttq.load(id);
      ttq.page();
    })(window, document, 'ttq');
  };

  const loadGA4 = (id) => {
    if (!id) return;
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(script);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', id, { send_page_view: true });
  };

  const track = (eventName, payload = {}) => {
    // Meta
    if (window.fbq) {
      const metaMap = {
        view_item: 'ViewContent',
        add_to_cart: 'AddToCart',
        begin_checkout: 'InitiateCheckout',
        purchase: 'Purchase',
        search: 'Search',
        view_collection: 'ViewCategory',
      };
      const metaEvent = metaMap[eventName] || eventName;
      window.fbq('track', metaEvent, {
        content_ids: payload.content_ids,
        content_type: payload.content_type || 'product',
        contents: payload.contents,
        value: payload.value,
        currency: payload.currency || currency,
        num_items: payload.num_items,
      });
    }

    // TikTok
    if (window.ttq) {
      const ttMap = {
        view_item: 'ViewContent',
        add_to_cart: 'AddToCart',
        begin_checkout: 'InitiateCheckout',
        purchase: 'CompletePayment',
      };
      const ttEvent = ttMap[eventName] || eventName;
      window.ttq.track(ttEvent, {
        contents: (payload.contents || []).map((c) => ({
          content_id: c.id,
          content_type: 'product',
          content_name: c.name,
          quantity: c.quantity || 1,
          price: c.price,
        })),
        value: payload.value,
        currency: payload.currency || currency,
      });
    }

    // GA4
    if (window.gtag) {
      window.gtag('event', eventName, {
        currency: payload.currency || currency,
        value: payload.value,
        items: payload.items || (payload.contents || []).map((c) => ({
          item_id: c.id,
          item_name: c.name,
          quantity: c.quantity || 1,
          price: c.price,
        })),
      });
    }

    // Shopify Web Pixels (si está disponible)
    if (window.analytics && typeof window.analytics.publish === 'function') {
      try {
        window.analytics.publish(eventName, payload);
      } catch (e) {
        // silent
      }
    }

    // Custom event para hooks externos
    document.dispatchEvent(new CustomEvent('cherry:track', { detail: { eventName, payload } }));
  };

  // Helpers para integrar fácil desde otros JS
  window.cherry = window.cherry || {};
  window.cherry.track = track;

  // Auto: cargar pixels al iniciar
  if (metaId) loadMetaPixel(metaId);
  if (tiktokId) loadTikTokPixel(tiktokId);
  if (gaId) loadGA4(gaId);

  // Listeners automáticos para eventos comunes:

  // 1) view_item — disparar cuando se carga PDP
  if (window.cherryProductData) {
    const p = window.cherryProductData;
    track('view_item', {
      content_ids: [p.id.toString()],
      contents: [{ id: p.id.toString(), name: p.title, price: (p.price || 0) / 100, quantity: 1 }],
      value: (p.price || 0) / 100,
      currency: currency,
    });
  }

  // 2) add_to_cart — escuchar el evento cherry:cart-add disparado desde quick view, o capturar add globalmente
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    // Esperar al siguiente tick para que el cart se actualice
    setTimeout(async () => {
      try {
        const cart = await fetch('/cart.js').then((r) => r.json());
        const lastItem = cart.items[cart.items.length - 1];
        if (lastItem) {
          track('add_to_cart', {
            content_ids: [lastItem.product_id.toString()],
            contents: [{ id: lastItem.product_id.toString(), name: lastItem.product_title, price: lastItem.price / 100, quantity: lastItem.quantity }],
            value: lastItem.final_line_price / 100,
            currency: currency,
            num_items: 1,
          });
        }
      } catch (err) { /* silent */ }
    }, 250);
  });

  // 3) begin_checkout — escuchar click en el botón checkout del carrito drawer
  document.addEventListener('click', async (e) => {
    const link = e.target.closest('a[href="/checkout"], a[href*="checkout"]');
    if (!link) return;
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      track('begin_checkout', {
        content_ids: cart.items.map((i) => i.product_id.toString()),
        contents: cart.items.map((i) => ({ id: i.product_id.toString(), name: i.product_title, price: i.price / 100, quantity: i.quantity })),
        value: cart.total_price / 100,
        currency: cart.currency || currency,
        num_items: cart.item_count,
      });
    } catch (err) { /* silent */ }
  });

  // 4) page_view en colecciones (view_collection)
  if (window.cherryCollectionData) {
    const collData = window.cherryCollectionData;
    track('view_collection', {
      content_ids: [collData.id?.toString()],
      content_name: collData.title,
    });
    // Evento extra cuando entra al Mayoreo
    if (collData.handle === 'mayoreo') {
      track('view_mayoreo', {
        content_name: 'Mayoreo',
        products_count: collData.products_count,
      });
    }
  }

  // 5) whatsapp_click — capturar clicks en links wa.me / WhatsApp
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href*="wa.me"], a[href*="api.whatsapp.com"], [data-cherry-wa]');
    if (!link) return;
    const source = link.dataset.waSource || (link.closest('[data-cherry-wa-panel]') ? 'panel' : 'button');
    track('whatsapp_click', {
      source,
      url: link.href || '',
      label: (link.textContent || '').trim().slice(0, 80),
    });
  });

  // 6) view_quickview, start_quiz, quiz_step, complete_quiz, subscribe_qora_box
  // se disparan desde cherry-quickview.js y cherry-quiz.js llamando a window.cherry.track(...)
})();
